const STORAGE_KEYS = {
    SELECTED_CATEGORIES: "teamconnector3_selected_categories",
    TEAM_MEMBERS: "teamconnector3_team_members",
    SESSION_TIMER: "teamconnector3_session_timer",
    REMAINING_SECONDS: "teamconnector3_remaining_seconds",
    IS_GAME_ACTIVE: "teamconnector3_is_game_active",
    TEAM_ACTIONS: "teamconnector3_team_actions",
    IS_SCORING_ENABLED: "is_scoring_enabled",
    CURRENT_ROUND: "teamconnector3_current_round",
    TOTAL_ROUND: "teamconnector3_total_round",
    USED_GLOBAL: "teamconnector3_used_global",
};

export const getStoredCategories = (defaultVal = []) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.SELECTED_CATEGORIES);
        return item ? JSON.parse(item) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredCategories = (categories) => {
    try {
        localStorage.setItem(
            STORAGE_KEYS.SELECTED_CATEGORIES,
            JSON.stringify(categories),
        );
    } catch (e) {}
};

export const getStoredMembers = (defaultVal = []) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.TEAM_MEMBERS);
        return item ? JSON.parse(item) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredMembers = (members) => {
    try {
        localStorage.setItem(
            STORAGE_KEYS.TEAM_MEMBERS,
            JSON.stringify(members),
        );
    } catch (e) {}
};

export const getStoredTimer = (defaultVal = 30) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.SESSION_TIMER);
        return item ? JSON.parse(item) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredTimer = (timer) => {
    try {
        localStorage.setItem(STORAGE_KEYS.SESSION_TIMER, JSON.stringify(timer));
    } catch (e) {}
};

export const getStoredRemainingSeconds = () => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.REMAINING_SECONDS);
        return item !== null ? parseInt(item, 10) : null;
    } catch (e) {
        return null;
    }
};

export const setStoredRemainingSeconds = (seconds) => {
    try {
        localStorage.setItem(
            STORAGE_KEYS.REMAINING_SECONDS,
            seconds.toString(),
        );
    } catch (e) {}
};

export const removeStoredRemainingSeconds = () => {
    try {
        localStorage.removeItem(STORAGE_KEYS.REMAINING_SECONDS);
    } catch (e) {}
};

export const getIsGameActive = () => {
    try {
        return localStorage.getItem(STORAGE_KEYS.IS_GAME_ACTIVE) === "true";
    } catch (e) {
        return false;
    }
};

export const setIsGameActive = (active) => {
    try {
        localStorage.setItem(
            STORAGE_KEYS.IS_GAME_ACTIVE,
            active ? "true" : "false",
        );
    } catch (e) {}
};

export const getStoredTeamActions = (defaultVal = []) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.TEAM_ACTIONS);
        return item ? JSON.parse(item) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredTeamActions = (actions) => {
    try {
        localStorage.setItem(
            STORAGE_KEYS.TEAM_ACTIONS,
            JSON.stringify(actions),
        );
    } catch (e) {}
};

export const getIsScoringEnabled = () => {
    try {
        const val = localStorage.getItem(STORAGE_KEYS.IS_SCORING_ENABLED);
        if (val === null) {
            // Also check alternate key
            const valAlt = localStorage.getItem(
                "teamconnector3_is_scoring_enabled",
            );
            if (valAlt !== null) return valAlt !== "false";
            return true; // Default is true
        }
        return val !== "false";
    } catch (e) {
        return true;
    }
};

export const setIsScoringEnabled = (enabled) => {
    try {
        localStorage.setItem(
            STORAGE_KEYS.IS_SCORING_ENABLED,
            enabled ? "true" : "false",
        );
    } catch (e) {}
};

export const getStoredCurrentRound = (defaultVal = 0) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.CURRENT_ROUND);
        return item !== null ? parseInt(item, 10) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredCurrentRound = (round) => {
    try {
        localStorage.setItem(STORAGE_KEYS.CURRENT_ROUND, round.toString());
    } catch (e) {}
};

export const getStoredTotalRound = (defaultVal = 1) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.TOTAL_ROUND);
        return item !== null ? parseInt(item, 10) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredTotalRound = (round) => {
    try {
        localStorage.setItem(STORAGE_KEYS.TOTAL_ROUND, round.toString());
    } catch (e) {}
};

export const getStoredUsedGlobal = (defaultVal = []) => {
    try {
        const item = localStorage.getItem(STORAGE_KEYS.USED_GLOBAL);
        return item ? JSON.parse(item) : defaultVal;
    } catch (e) {
        return defaultVal;
    }
};

export const setStoredUsedGlobal = (used) => {
    try {
        localStorage.setItem(STORAGE_KEYS.USED_GLOBAL, JSON.stringify(used));
    } catch (e) {}
};
